import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import OTPInput from 'otp-input-react';
import NavBarAuth from '../../../../components/navbar/navbarAuth';
import AlertContext from '../../../../Context/Alert/AlertContext';
import { BaseURL } from '../../../../Files/BaseURL';
import { CreateLog } from '../../../../Files/AddChecker';

const OTPScreen = () => {
  const [OTP, setOTP] = useState('');
  const [Email, setEmail] = useState('');
  const [Phone, setPhone] = useState('')
  const [loading, setLoading] = useState(false);
  const [countdown, setCountdown] = useState(30);
  const [canResend, setCanResend] = useState(false);
  const alertContext = useContext(AlertContext);
  const { showAlert } = alertContext;
  const navigate = useNavigate();
  const location = useLocation();
  const Name = location.state.name;
  const token = sessionStorage.getItem('signtoken');
  const[resendLoading,setResendLoading]=useState(false)


  // Countdown timer effect
  useEffect(() => {
    let timer;
    if (countdown > 0) {
      timer = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);
    } else {
      setCanResend(true);
    }
    return () => clearInterval(timer);
  }, [countdown]);

  const fetchEmail = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${BaseURL}/api/auth/getuseremail`, {
        headers: {
          'auth-token': token,
        },
      });
      const data = await response.json();
      setEmail(data.Email);
      setPhone(data.Phone)
    } catch (error) {
      showAlert(error.message, 'danger');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEmail();
  }, []);

  const handleVerifyOTP = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${BaseURL}/api/authlogin/verifyOTP`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ token, otp: OTP }),
      });

      const data = await response.json();

      if (data.success) {
        showAlert('OTP verified successfully!', 'success');
        localStorage.setItem("p@token",data.AuthToken)
        const routeMap = {
          Pending: '/user-dashboard/upl_missing_doc',
          Request: '/user-dashboard/not-verify',
          Approved: '/user-dashboard/',
          Declined: '/user-dashboard/error',
        };
        const logResponse = await CreateLog("Login", data, "User" )
        if(data.Verification=="Approved"){
          if(data.BusinessProfile==="Approve"){
            navigate('/user-dashboard/');
          }else{
            navigate('/user-dashboard/');
          }

        }else{
          navigate(routeMap[data.Verification]);
        }
      } else {
        showAlert(data.message, 'danger');
      }
    } catch (error) {
      showAlert('Error verifying OTP', 'danger');
    } finally {
      setLoading(false);
    }
  };

  const handleResendOTP = async () => {

    if (!canResend) return;
    

    setResendLoading(true);

    try {
      const Base= Name=="phone"?"/SendOTPMobileagain":"/SendOTPEmailagain"
      const response = await fetch(`${BaseURL}/api/authlogin${Base}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ token }),
      });
      const data = await response.json();
      showAlert(data.message, 'success');

      setCountdown(30);
      setCanResend(false);

    } catch (error) {
      showAlert('Failed to resend OTP. Please try again.', 'danger');
        setResendLoading(false);
    } finally {
      setResendLoading(false);
    }
  };

  return (
    <>
      <NavBarAuth />
      <div className="flex justify-center items-center bg-gray-100 py-20">
        <div className="mx-6 bg-white p-8 rounded-lg shadow-md">
          <h2 className="text-2xl font-bold mb-4">Welcome to Paycott.</h2>
          <p className="text-gray-600 font-pop mb-6 max-w-sm">
            We sent a verification code to your {Name === 'phone' ? 'phone number' : 'email'} <span className='font-bold'>{Name === 'phone' ? `+${Phone}` : Email}</span>
          </p>
          <div className="mb-4 w-full px-6 border-2 border-transparent flex items-center justify-center font-pop text-lg rounded-full bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none">
            <OTPInput value={OTP} onChange={setOTP} autoFocus OTPLength={6} otpType="number" disabled={false} secure />
          </div>
          <button
            onClick={handleVerifyOTP}
            className="my-4 w-full bg-green-500 hover:bg-transparent hover:bg-white-500 font-semibold hover:text-black font-pop text-xl py-3 px-4 border border-black-500 hover:border-green-500 rounded-full text-white animate__animated animate__backInUp"
            disabled={loading}
          >
            {loading ? 'Processing...' : 'Login'}
          </button>
          <p className="text-gray-400 font-pop mt-6 max-w-sm text-center">Didn't receive the code</p>

          <p 
            className={`font-pop cursor-pointer hover:underline mb-6 max-w-sm text-center ${
              canResend ? 'text-primarygreen' : 'text-gray-400'
            }`} 
            onClick={handleResendOTP}
          >
            {canResend ? 'Resend' : `Resend in ${countdown}s`}
          </p>

        </div>
      </div>
    </>
  );
};

export default OTPScreen;
